
import { GameObjects } from "phaser";

export class GButton extends GameObjects.Container {

    constructor(scene, x, y, config) {
        super(scene, x, y);

        // Add this container to the scene
        scene.add.existing(this);

        // Default configuration
        const { texturePack, idleTexture, hoverTexture, clickedTexture, disabledTexture, text, icon, onClick, isDisabled, isSelected , selectedTexture , nineslice, clickEvent } = config;

        // Create the button sprite with the idle texture
        if(nineslice){
            this.buttonSprite = scene.add.nineslice(0, 0, texturePack, idleTexture, 343*2, 104, 32, 32).setInteractive();
        }else {
            this.buttonSprite = scene.add.sprite(0, 0, texturePack ,idleTexture).setInteractive();
        }

        let lastClickTime = 0;  // Track the last click timestamp (for debounce)
        const debounceDelay = 50; // Minimum time between clicks in ms

        
        this.buttonClickSound = scene.sound.add('button-click');
        //this.buttonSprite = scene.add.sprite(0,0,texturePack, idleTexture).setInteractive();
        //this.buttonSprite =   scene.add.sprite(0, 0, "pack", "Header 1 - Button BG - Clicked.png");
        // console.log(0, 0, texturePack ,idleTexture)
        // console.log(0, 0, 'pack', 'Header 1 - Button BG - Default.png')
       
        // Add button sprite to the container
        this.add(this.buttonSprite);

        this.allTexts = text;

        // Add optional text to the button
        if (text) {
            this.label = scene.add.text(0, 0, text.value, text.style).setOrigin(0.5);
            this.label.setFontStyle("700")
            this.add(this.label);
        }

        // Add optional icon to the button
        if (icon) {
            //this.icon = scene.add.image(0, 0, icon).setOrigin(0.5);
            this.iconX = 0

            if(icon.align !== undefined){

                if(icon.align == 'left') {
                    this.iconX = this.getBounds().width/2 * - 1 + 44
                    this.label.x += 16
                } else {
                    //this.iconX = this.getBounds().width/2 * - 1
                }
                
            }
            
            this.icon = scene.add.sprite(this.iconX, 0, texturePack ,icon.image);
            this.icon.setScale(icon.scale)
            this.add(this.icon);
        }

        // Store the different states of the button
        this.texturePack = texturePack;
        this.idleTexture = idleTexture;
        this.hoverTexture = hoverTexture;
        this.clickedTexture = clickedTexture;
        this.disabledTexture = disabledTexture;
        this.selectedTexture = selectedTexture || clickedTexture;
        this.isDisabled = isDisabled || false;
        this.selected = isSelected || false;
        this.clickEvent = clickEvent || "post"

        // Set initial state
        if (this.isDisabled) {
            this.setDisabled();
        } else {
            this.setIdle();
        }

        // // Set up interactive states
        // this.buttonSprite.on('pointerover', () => {
        //     if (!this.isDisabled) {
        //         this.setHover();
        //     }
        // });

        // this.buttonSprite.on('pointerout', () => {
        //     if (!this.isDisabled) {
        //         this.setIdle();
        //     }
        // });

        // Capture the original scale of the button
        this.originalScaleX = this.scaleX;
        this.originalScaleY = this.scaleY;

        this.buttonSprite.on('pointerdown', () => {
            if (!this.isDisabled) {
                const now = Date.now();
                if (now - lastClickTime > debounceDelay) {
                    this.buttonClickSound.play();
                    this.setClicked();
                    scene.tweens.add({
                        targets: this,
                        scaleX: this.originalScaleX * 0.85,
                        scaleY: this.originalScaleY * 0.85,
                        duration: 50, // Duration of the tween (in milliseconds)
                        ease: 'Power2'
                    });
                }
              
            }
        });

        this.buttonSprite.on('pointerup', () => {

            const now = Date.now();
            if (now - lastClickTime > debounceDelay) {
                lastClickTime = now; // Update the last click time
                if (onClick && this.clickEvent == "pre") onClick();
                scene.tweens.add({
                    targets: this,
                    scaleX: this.originalScaleX ,
                    scaleY: this.originalScaleY,
                    duration: 50, // Duration of the tween (in milliseconds)
                    ease: 'Power2',
                    onComplete: () => {
                        if(!this.isDisabled && !this.isSelected){
                            this.setIdle();
                        }
                        if (onClick && this.clickEvent == "post") onClick();
                        // Trigger the custom function after the tween completes
                        // Call the provided callback function
                      
                    }
                });

            }

              
            
        });

        this.buttonSprite.on('pointerout', () => {
            if(!this.isSelected){
                this.setIdle();
                scene.tweens.add({
                    targets: this,
                    scaleX: this.originalScaleX ,
                    scaleY: this.originalScaleY,
                    duration: 50, // Duration of the tween (in milliseconds)
                    ease: 'Power2'
                });            
            }
                
        });

    }

     // Override the setScale method
     setScale(x, y = x) {
        // Custom behavior: Log or handle events when setScale is called
        //console.log(`setScale called with x: ${x}, y: ${y}`);

        // Call the original setScale method to ensure normal behavior
        super.setScale(x, y);

        // Optionally trigger any other actions you want when setScale is called
        this.onScaleChanged(x, y); // Custom event or behavior
    }

    // Custom method to handle scale changes
    onScaleChanged(newScaleX, newScaleY) {
        this.originalScaleX = newScaleX;
        this.originalScaleY = newScaleY;
        //console.log(`Container's scale has been changed to X: ${newScaleX}, Y: ${newScaleY}`);
        // You can handle custom logic here, like adjusting children positions, etc.
    }

    // Set the button to idle state
    setIdle() {
        this.buttonSprite.setTexture(this.texturePack, this.idleTexture);
        if(this.label){
            this.label.setColor(this.allTexts.style.color);
        }
    }

    // // Set the button to hover state
    // setHover() {
    //     if (this.hoverTexture) {
    //         this.buttonSprite.setTexture(this.hoverTexture);
    //     }
    // }

    // Set the button to clicked state
    setClicked() {
        if (this.clickedTexture) {
            this.buttonSprite.setTexture(this.texturePack, this.clickedTexture);
        }

        if(this.label &&  this.allTexts.styleSelected !== undefined){
            this.label.setColor(this.allTexts.styleSelected.color);
        }
    }

    // Set the button to disabled state
    setDisabled() {
        if (this.disabledTexture) {
            this.buttonSprite.setTexture(this.texturePack, this.disabledTexture);
        }

        if(this.label &&  this.allTexts.styleDisabled !== undefined){

            this.label.setColor(this.allTexts.styleDisabled.color);
        }


        this.isDisabled = true;
        this.buttonSprite.disableInteractive();
    }

    // Enable the button
    enable() {
        this.isDisabled = false;
        this.buttonSprite.setInteractive();
        this.setIdle();
        if(this.label){
            this.label.setColor(this.allTexts.style.color);
        }
    }

    setSelected(){
        //console.log("pointerout", this.isSelected)
        this.isSelected = !this.isSelected;
        if(this.isSelected){
            this.buttonSprite.setTexture(this.texturePack, this.selectedTexture);
            if(this.label &&  this.allTexts.styleSelected !== undefined){
                this.label.setColor(this.allTexts.styleSelected.color);
            }
        }else{
            this.buttonSprite.setTexture(this.texturePack, this.idleTexture);
            if(this.label){
                this.label.setColor(this.allTexts.style.color);
            }

        }

        
    }

    setOriginOver(x,y){
        this.setOrigin(x,y);
    }
}